import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../images/MegaLogo.png';
import { mobile } from '../responsive';
import { Menu } from '@material-ui/icons';
import { setShowNav } from '../redux/sideNavSlice';
import { useDispatch } from 'react-redux';

const Container = styled.div`
    width: 100%;
    min-height: 10vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${props => props.pfVersion ? 'none' : 'teal'};
    position: ${props => props.pfVersion ? '' : 'sticky'};
    top: 0;
    border-radius: 5px 5px 0 0;
    z-index: 2;
`

const LogoContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Logo = styled.img`
    width: 100px;
    height: 65px;
    padding: 5px;
    
    
`

const HeadingContainer = styled.div`
    flex: 3
    display: flex;
    align-items: center;
    flex-direction: column;
    
`

const LoginContainer = styled.div`
    flex: 1;
    justify-content: flex-end;
    display: flex;
    align-items: center;
   
`

const Heading = styled.h1`
    margin: 0;
    text-align: center;
    ${mobile({  
                display: 'none'
            })};
`

const SubHeading = styled.h1`
    text-align: center;
    font-weight: 300;
    font-size: 20px;
    margin: 0;
    ${mobile({  
                fontSize: '20px'
            })};
`

const HeaderText = styled.p`
    margin: 0px 10px;
    cursor: pointer;
    ${mobile({  
                display: 'none'
            })};
`

const StyledLink = styled(Link)`
    cursor: pointer;
`

const HamburgerMenu = styled.div`
    display: none;
    padding: 5px;
    cursor: pointer;
    ${mobile({  
                display: 'flex',
                justifyContent: 'flex-end',
                minWidth: '50px'
            })};
`

const Header = ({pfVersion}) => {

    const dispatch = useDispatch();

    const handleMenuClick = async () => {
        await dispatch(setShowNav());
    };

    return (
        <Container pfVersion={pfVersion}>
            <LogoContainer>
           {pfVersion ?  <Logo src={logo} 
                    alt = 'Mega Logo'>
                </Logo>
                
            : <StyledLink to="/">
                <Logo src={logo} 
                    alt = 'Mega Logo'>
                </Logo>
            </StyledLink>
            }
            </LogoContainer>
            <HeadingContainer>
                <Heading>MEGA PLAZA INVESTMENT LIMITED</Heading>
                <SubHeading>{pfVersion ? 'Payment Voucher' : 'Payment Voucher Generator'}</SubHeading>
            </HeadingContainer>

            {!pfVersion ? (<LoginContainer>

                <HeaderText>SIGN IN</HeaderText>
                <HeaderText>SIGN UP</HeaderText>
                <HamburgerMenu onClick={() => handleMenuClick()}><Menu /></HamburgerMenu>
                </LoginContainer>
                ) : 
                (
                    <LogoContainer>
                    <Logo src={logo} 
                        alt = 'Mega Logo'>

                    </Logo>
                    </LogoContainer>
                )}

        </Container>
    )
}

export default Header
